import * as React from 'react';
const SizeContext = React.createContext(undefined);
export const SizeContextProvider = ({ children, size }) => (React.createElement(SizeContext.Consumer, null, (originSize) => (React.createElement(SizeContext.Provider, { value: size || originSize }, children))));
export default SizeContext;
